import {
  GetCountryLookUpType,
  GetInvoiceListTypeResponse,
  InvoiceAuditListQueryParams,
} from '../../../../types/Invoicing/InvoiceAuditReport/invoiceAuditReportType'
import {
  getAuthenticatedRequestConfig,
  useAxios,
} from '../../../../utils/apiUtils'
import { AllowedHttpMethods, InvoiceAuditReportApiConfig } from '../../apiList'

const getInvoiceAuditList = async (
  queryParams: InvoiceAuditListQueryParams,
): Promise<GetInvoiceListTypeResponse> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: InvoiceAuditReportApiConfig.invoiceAuditList,
    method: AllowedHttpMethods.get,
    params: queryParams,
  })

  const response = await useAxios(requestConfig)
  return response.data
}
const getCountryLookup = async (): Promise<GetCountryLookUpType[]> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: InvoiceAuditReportApiConfig.getCountryLookup,
    method: AllowedHttpMethods.get,
  })

  const response = await useAxios(requestConfig)
  return response.data
}
const invoiceAuditReportApi = {
  getInvoiceAuditList,
  getCountryLookup,
}
export default invoiceAuditReportApi
